import React, { useState } from 'react';
import { Discount, DiscountResponse } from '../models/APIModels';
import { axiosKK } from '../services/networkRequest';
import SubmitButton from './SubmitButton';
import Label from './Label';
import Error from './Error';

interface DiscountCodeProps {
  successfulDiscount: (discount: Discount) => void;
}

function DiscountComponent(props: DiscountCodeProps): JSX.Element {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [discountCode, setDiscountCode] = useState<string>('');
  const [error, setError] = useState<string>('');

  return (
    <div className="discount-info">
      <Label htmlFor="discount" className="discount-label">
        Discount
      </Label>
      <div className="input-and-btn">
        <input
          id="discount"
          type="text"
          placeholder="Enter Discount Code"
          value={discountCode}
          onChange={(event) => {
            setError('');
            setDiscountCode(event.target.value.toUpperCase());
          }}
        />
        <SubmitButton
          type="button"
          isSubmitting={submitting}
          onClick={(event) => {
            event.preventDefault();
            setSubmitting(true);
            setError('');

            axiosKK
              .get<DiscountResponse>(`/discountCode/${discountCode}`)
              .then(({ data }) => {
                const discount = data?.discount;
                if (discount?.deletedAt) {
                  setError('Discount code not found or is no longer active.');
                  return;
                }
                if (discount?.expires && new Date(discount.expires) < new Date()) {
                  setError('This discount code has expired.');
                  return;
                }
                props.successfulDiscount(discount);
              })
              .catch((err) => {
                console.error(err);
                const serverError: string = err?.response?.data?.error;
                setError(serverError || 'Something went wrong. Please try again.');
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          Submit
        </SubmitButton>
      </div>
      <Error error={error} touched={!!error} removeBreak />
    </div>
  );
}

export default DiscountComponent;
